import { Component } from '@angular/core';

@Component({
  selector: 'app-message-info_detail',
  templateUrl: './message-info_detail.component.html'
})
export class MessageInfoDetailComponent {

  setMsgList(msgList: Array<string>) {
    let message = '';
    for (var i = 0; i < msgList.length; i++) {
      if (i === msgList.length - 1) {
        message = message + msgList[i];
      } else {
        message = message + msgList[i] + '\n';
      }
    }
    document.getElementById('msgDetailDiv').innerText = message;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  setMsg(msg: string) {
    document.getElementById('msgDetailDiv').innerText = msg;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  setMsgListNoTopScroll(msgList: Array<string>) {
    let message = '';
    for (var i = 0; i < msgList.length; i++) {
      if (i === msgList.length - 1) {
        message = message + msgList[i];
      } else {
        message = message + msgList[i] + '\n';
      }
    }
    document.getElementById('msgDetailDiv').innerText = message;
    document.body.scrollTop = 1;
    document.documentElement.scrollTop = 1;
  }

  setMsgNoTopScroll(msg: string) {
    document.getElementById('msgDetailDiv').innerText = msg;
    document.body.scrollTop = 1;
    document.documentElement.scrollTop = 1;
  }

  clearMsg() {
    document.getElementById('msgDetailDiv').innerText = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/message-info_detail/message-info_detail.component.ts